module.exports = __webpack_public_path__ + "img/CN-邀请3.851102f8.png";